import { render, staticRenderFns } from "./groupnotes.vue?vue&type=template&id=be5e13c6&scoped=true"
import script from "./groupnotes.vue?vue&type=script&lang=ts"
export * from "./groupnotes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5e13c6",
  null
  
)

export default component.exports